import React from 'react';
import './LandingPage.css';

const LandingPage = ({ onSelectGame }) => {
    return (
        <div className="lp-landing-container">
            <main className="lp-landing-content">
                <div className="lp-game-grid">
                    {/* Mojie Original Card */}
                    <div className="lp-game-card">
                        <div className="lp-card-header classic">
                            <span>🙂</span>
                        </div>
                        <div className="lp-card-body">
                            <h3 className="lp-game-name">mojie classic</h3>
                            <p className="lp-game-desc">
                                The daily movie emoji challenge. Guess the movie from 5 levels of emoji clues.
                            </p>
                            <div className="lp-card-buttons">
                                <button className="lp-pill-btn" onClick={() => onSelectGame('classic')}>Play</button>
                            </div>
                        </div>
                    </div>

                    {/* Reel Connections Card */}
                    <div className="lp-game-card">
                        <div className="lp-card-header connections">
                            <span className="lp-card-badge">New</span>
                            <span>🧩</span>
                        </div>
                        <div className="lp-card-body">
                            <h3 className="lp-game-name">iconnect</h3>
                            <p className="lp-game-desc">
                                16 emojis, 4 movies, 1 theme. Group the emojis correctly to win.
                            </p>
                            <div className="lp-card-buttons">
                                <button className="lp-pill-btn" onClick={() => onSelectGame('connections')}>Play</button>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default LandingPage;
